import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class ClassGroupModel extends Model 
{
	@attr name;
	@attr format;
	@attr discipline;
	@attr category;
	@attr('date') endTime;
	@attr('date') startTime;
	@attr('date') postTime;
	@attr status;
	@attr id1;
	@attr id2;
	@attr id3;
	@attr weather1;
	@attr weather2;
	@attr weather3;
	@attr pts1;
	@attr pts2;
	@attr pts3;
	@attr pts4;
	@attr pts5;
	
	@belongsTo('event', {inverse: 'classGroups', async: true}) EventId;
	@belongsTo('course', {inverse: 'classGroups', async: true}) CourseId;
	@hasMany('class', {inverse: 'ClassGroupId', async: true}) classes;
	@hasMany('result', {inverse: 'ClassGroupId', async: true}) results;
	@hasMany('team-result', {inverse: 'ClassGroupId', async: true}) teamResults;
	@hasMany('jury-Member', {inverse: 'ClassGroupId', async: true}) juryMembers;
	
	get resultsDNF()
	{
		return this.filterResults((r) => (r.status == "DNF"));
	}
	get resultsDNS()
	{
		return this.filterResults((r) => (r.status == "DNS"));
	}
	get resultsDSQ()
	{
		return this.filterResults((r) => (r.status == "DSQ"));
	}
	get resultsSUS()
	{
		return this.filterResults((r) => (r.status == "SUS"));
	}
	get resultsMP()
	{
		return this.filterResults((r) => (r.status == "MP"));
	}
	get resultsRAL()
	{
		return this.filterResults((r) => (r.status == "RAL"));
	}
	get resultsNPS()
	{
		return this.filterResults((r) => (r.status == "NPS"));
	}
	get resultsOK()
	{
		return this.filterResults((r) => (r.status == "OK" && r.finishTime != undefined));
	}
	get resultsFinished()
	{
		return this.filterResults((r) => (r.status != "OK" || r.finishTime != undefined));
	}
	get resultsNotFinished()
	{
		return this.filterResults((r) => (r.status == "OK" && r.finishTime == undefined));
	}
	
	filterResults(fn)
	{
		return this.get('results').then((rs) => (rs.filter((r) => (fn(r)))));
	}
	
	get resultsSorted()
	{
		return this.get('results').then((rs) => (rs.slice().sort((a,b) => 
		{
			var aTime = a.get('totalTimeInMilliseconds');
			var bTime = b.get('totalTimeInMilliseconds');
		
			var aPlace = a.get('place');
			var bPlace = b.get('place');
		
			var aStatus = a.get('status');
			var bStatus = b.get('status');
		
			var aID = a.get('id');
			var bID = b.get('id');
		
			//if both results have times, sort on time
			if(aTime != null && bTime != null && aStatus == "OK" && bStatus == "OK")
			{
				//if the times are the same sort on place
				if(aTime == bTime)
				{
					if(aPlace != null && bPlace != null)
						return aPlace>bPlace?1:aPlace<bPlace?-1:0
					if(aPlace != null)
						return -1
					if(bPlace != null)
						return 1
				}
				return (aTime>bTime ? 1 : (aTime<bTime ? -1 : 0));
			}
			if(aTime != null && aStatus == "OK")
				return -1;
			if(bTime != null && bStatus == "OK")
				return 1;
		
			//no times for either a or b
			//first sort by status, then by id
		
			//if both have the same status, sort by id
			if(aStatus == bStatus)
			{
				return (aID>bID ? 1 : (aID<bID ? -1 : 0));
			}
			//OK is above everything, SUS is at the bottom
			if(aStatus == "SUS")
			{
				return 1;
			}
			if(bStatus == "SUS")
			{
				return -1;
			}
			if(aStatus == "OK")
			{
				return -1;
			}
			if(bStatus == "OK")
			{
				return 1;
			}
		})));
	}
	get teamResultsSorted()
	{
		return this.get('teamResults').then((rs) => (rs.slice().sort((a,b) => 
		{
			var aTime = a.totalTimeInMilliseconds;
			var bTime = b.totalTimeInMilliseconds;
		
			a.status = "OK";
			b.status = "OK";
		
			//if both have totalTimes, and are OK sort by them
			if(aTime != null && bTime != null && (a.status == "OK" && b.status == "OK"))
			{
				return aTime>bTime ? 1 : aTime<bTime ? -1 : (a.id>b.id ? 1:-1);
			}
			//if a has a totalTime, it is on top
			if(aTime != null && a.status == "OK")
			{
				return -1;
			}
			//if b has a totalTime, it is on top
			if(bTime != null && b.status == "OK")
			{
				return 1;
			}
		
			//if nither have totalTimes, look to see which has the most split times, then sort by elapsed at that split
			var aSplits = a.splits;
			var bSplits = b.splits;
		
			var aNumSplits = 0;
			var bNumSplits = 0;
		
			var aLastSplit = 0;
			var bLastSplit = 0;
		
			if(aSplits != undefined)
			{
				aSplits.forEach(function(split, index)
				{
					if(split.elapsed != null)
					{
						aNumSplits++;
						if(index > aLastSplit)
						{
							aLastSplit = index;
						}
					}
				});
			}
			if(bSplits != undefined)
			{
				bSplits.forEach(function(split, index)
				{
					if(split.elapsed != null)
					{
						bNumSplits++;
						if(index > bLastSplit)
						{
							bLastSplit = index;
						}
					}
				});
			}
		
			if(aNumSplits == 0 && bNumSplits == 0)
			{
				//final sort by id as fallback
				return (a.id>b.id?1:-1);		
			}
		
			if(aNumSplits != bNumSplits)
			{
				return aNumSplits>bNumSplits ? -1 : 1; 
			}
			else
			{
				return aSplits[aLastSplit].elapsed>bSplits[bLastSplit].elapsed 
				? 1 : aSplits[aLastSplit].elapsed<bSplits[bLastSplit].elapsed  ? -1 : 0; 
			}
			return 0;
		})));
	}
}
